export default {
  network: {
    normal: "Unknown error",
    unavailable:
      "The current network is unavailable, please check your network settings",
    failedReceiveMessage: "Collect message failed",
    disconnect: "Connection disconnected",
    failedReceiveHistoryMessage: "Failed to get chat history",
    // succeededReceiveHistoryMessage: "获取历史消息成功",
    failedLike: "Failed to like",
    succeededLike: "Like successfully",
  },
  chatInput: {
    inputPrompt: "Please enter text",
  },
  tip: {
    aiTip:
      "The content is generated by AI and cannot be guaranteed to be completely trustworthy",
    loading: "Loading...",
  },
  mesage: {
    like: "Like",
    teach: "Train",
    makeMeBetter: "Let me become better",
    teachMe: "Teach me",
    betterAnswer: "Please leave a better and more correct answer",
    throwLink: "Send a link",
    correctAnswer:
      "Find the source of the correct answer, I will work hard to learn something",
    pickTeachReson: "At least pick one reason to be a teacher",
    feedSucessed: "Feedback success",
    submit: "Submit",
  },
  time: {
    year: "Year",
    month: "Month",
    day: "Day",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday",
    yesterday: "Yesterday",
  },
  topic: {
    recommendedReply: "Recommended response：",
    nextTopic: "Next topic：",
    refresh: "Refresh", // 刷新话题按钮
    promptHeading:
      "After clicking Refresh, new topic recommendations will appear.", // 刷新话题提示语
    noMoreReminders: "No longer remind", // 刷新话题弹窗 [不再提醒]按钮
    cancle: "Cancel", // 刷新话题弹窗 [取消]按钮
    confirm: "Determine", // 刷新话题弹窗 [确定]按钮
    noMoreTopics:
      "There are no more topics at present, and we are working hard to produce (๑･`◡´･๑), so stay tuned",
  },
};